export default "__VITE_ASSET__DZc9KZfF__"